import React, { useEffect } from "react";
import dayjs from "dayjs";
import { useTranslate } from "../../../../components/TranslationText";
import { ServiceEventNames, ServiceActionTypes, HorseGender } from '../../shared/utils/ServicesConstants';
import { LeaseFieldNames } from '../utils/HorseLeasingConstants';
import { TranslationKeys } from '../../../../constants/TranslationKeys';
import { useFormContext, useWatch } from "react-hook-form";
import EahsForm from "../../../../components/EahsForm";
import FormDateInput from "../../../../components/FormInputs/FormDateInput";
import FormCheckbox from "../../../../components/FormInputs/FormCheckbox";

const HorseLeasingLeaseDetailsSection = ({
    isReadOnly
}) => {
    const { translate } = useTranslate();
    const { control, formState: { errors }, clearErrors } = useFormContext();
    const canCoverRegister = useWatch({
        control,
        name: LeaseFieldNames.CAN_COVER_REGISTER,
        defaultValue: false
    });
    const canParticipateBeauty = useWatch({ control, name: LeaseFieldNames.CAN_PARTICIPATE_BEAUTY, defaultValue: false });
    const canRegisterOther = useWatch({ control, name: LeaseFieldNames.CAN_REGISTER_OTHER, defaultValue: false });
    const canImportExport = useWatch({ control, name: LeaseFieldNames.CAN_IMPORT_EXPORT, defaultValue: false });
    const horseGender = useWatch({ control, name: LeaseFieldNames.HORSE_GENDER, defaultValue: "" });

    const isMare = horseGender?.toLowerCase?.() === HorseGender.MARE.toLowerCase();

    useEffect(() => {
        if (canParticipateBeauty || canCoverRegister || canRegisterOther || canImportExport) {
            clearErrors(LeaseFieldNames.CAN_PARTICIPATE_BEAUTY);
        }
    }, [canParticipateBeauty, canCoverRegister, canRegisterOther, canImportExport, clearErrors]);

    return (
        <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate(TranslationKeys.LEASE_DETAILS, "Lease Details")}>
            <div className="row">
                <div className="col-md-6">
                    <FormDateInput
                        type="date"
                        label={translate(TranslationKeys.LEASE_START_DATE, "Start Date")}
                        name={LeaseFieldNames.LEASE_START_DATE}
                        required
                        disabled={isReadOnly}
                        maxDate={dayjs().format("YYYY-MM-DD")}
                    />
                </div>
                <div className="col-md-6">
                    <FormDateInput
                        type="date"
                        label={translate(TranslationKeys.LEASE_END_DATE, "End Date")}
                        name={LeaseFieldNames.LEASE_END_DATE}
                        required
                        disabled={isReadOnly}
                        minDate={dayjs().add(1, 'day').format("YYYY-MM-DD")}
                    />
                </div>
            </div>

            <div className="mt-4">
                <h5>{translate(TranslationKeys.LESSEE_PERMISSIONS, "Lessee Permissions")} <span className="text-danger">*</span></h5>
                <FormCheckbox hideError={true} label={translate(TranslationKeys.PARTICIPATE_IN_BEAUTY_SHOWS, "Participate in Beauty Shows")} name={LeaseFieldNames.CAN_PARTICIPATE_BEAUTY} disabled={isReadOnly} />
                <FormCheckbox label={translate(TranslationKeys.COVERING_AND_FOAL_REGISTRATION, "Covering and Foal Registration")} name={LeaseFieldNames.CAN_COVER_REGISTER} disabled={isReadOnly} />
                {isMare && (
                    <FormCheckbox label={translate(TranslationKeys.REGISTER_FOALS_FOR_OTHER_OWNERS, "Register Foals For Other Owners")} name={LeaseFieldNames.CAN_REGISTER_OTHER} disabled={isReadOnly || !canCoverRegister} />
                )}
                <FormCheckbox label={translate(TranslationKeys.IMPORT_AND_EXPORT, "Import and Export")} name={LeaseFieldNames.CAN_IMPORT_EXPORT} disabled={isReadOnly} />

                {errors[LeaseFieldNames.CAN_PARTICIPATE_BEAUTY] && (
                    <div className="text-danger mt-1" style={{ fontSize: '0.875em' }}>
                        {errors[LeaseFieldNames.CAN_PARTICIPATE_BEAUTY].message}
                    </div>
                )}
            </div>
        </EahsForm>
    );
};

export default HorseLeasingLeaseDetailsSection;
